/* eslint-disable */

import Component from 'gia/Component'

export default class ToggleList extends Component {
  constructor(element) {
    super(element)
    this.mylist = this.element.querySelector(
      '.m-incentive-tile__image .m-add-to-list'
    )
    this.listContainer = this.mylist.querySelector('.m-my-lists')
    this.toggle = this.element.querySelector('.m-toggle-list')
  }

  mount() {
    this.toggle.addEventListener('click', () => {
      if (this.listContainer.classList.contains('make-flex')) {
        this.listContainer.classList.remove('make-flex')
      } else {
        this.listContainer.classList.add('make-flex')
      }
      if (this.mylist.classList.contains('addZIndex')) {
        this.mylist.classList.remove('addZIndex')
      } else {
        this.mylist.classList.add('addZIndex')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ToggleList.js